/*eslint no-sequences: "off"*/
/*eslint no-empty-pattern: "off"*/

import { createSlice } from "@reduxjs/toolkit";
import { IRightDrawer } from './interfaces';
import { initState } from "./init.state";

export const RightDrawerSLice = createSlice({
  name: "rightDrawer",
  initialState: initState,
  reducers: {
    SetDrawer: (state: IRightDrawer, action: any) => {
      return {
        ...state,
        ...action.payload,
        show: true,
      };
    },
    ResetDrawer: () => {
      return initState
    },
    HideDrawer: () => {
      return initState
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  SetDrawer,
  ResetDrawer,
  HideDrawer,
} = RightDrawerSLice.actions;

export default RightDrawerSLice.reducer;
